import { render, staticRenderFns } from "./ViewDocuments.vue?vue&type=template&id=6be2d783&"
import script from "./ViewDocuments.vue?vue&type=script&lang=js&"
export * from "./ViewDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports